import {axiosInstance} from "./axios";

export const getUserToken = () => axiosInstance.get('/get-user-token');

export const saveVisit = (day) => axiosInstance.post('/visits', {
   day: day,
   userhash: localStorage.getItem("token"),
   edm_id: window.location.href.split('#edm=')[1]
});